import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { catchError, tap } from 'rxjs/operators';
import { AppStoreInterface, Environment } from 'src/app/models';
import Utils, { WINDOW } from 'src/app/utils/utils';

@Injectable({
  providedIn: 'root',
})
export class AppStore {
  private readonly _state = new BehaviorSubject<AppStoreInterface>({
    client: null,
    env: null,
    error: null,
    origin: 'personas',
  });
  readonly httpWithoutInterceptors: HttpClient;

  constructor(
    private readonly httpBackend: HttpBackend,
    @Inject(WINDOW) private window: Window
  ) {
    this.httpWithoutInterceptors = new HttpClient(httpBackend);
  }

  get env(): any | null {
    return this._state.getValue().env;
  }

  get origin(): any | null {
    return this._state.getValue().origin;
  }

  private getOriginUrl() {
    const validOrigins = new Set(Object.keys(this.env.validOrigins));
    const messageHandler = (event: any) => {
      if (event.origin !== this.env.redirects.urlBase) {
        return;
      }
      if (event?.data) {
        const currentUrl = event.data?.url;
        const origin = Utils.getOriginFromURL(currentUrl, validOrigins);
        this.setOrigin(origin);
        window.removeEventListener('message', messageHandler);
      }
    };
    window.addEventListener('message', messageHandler);
  }

  // ACTIONS
  public appLoaded() {
    return this.httpWithoutInterceptors
      .get<any>(environment.configUrl)
      .pipe(
        tap((config) => {
          this.setEnv(config);
        }),
        tap(() => {
          this.getOriginUrl();
        }),
        catchError((error) => this.handleError(error))
      )
      .toPromise();
  }

  handleError(error: any): any {
    throw new Error(error instanceof Error ? error.message : String(error));
  }

  private setEnv(env: Environment) {
    const currentState = this._state.getValue();
    this._state.next({
      ...currentState,
      env,
    });
  }

  private setOrigin(origin: string) {
    const currentState = this._state.getValue();
    this._state.next({
      ...currentState,
      origin,
    });
  }

  public getUrlByOperation(operation: string | undefined): string {
    if (!this.env) {
      throw new Error('env is null');
    }
    if (!operation) {
      throw new Error(`${operation} doesn't exists`);
    }
    const { domain, basePath, version } = this.env.api;
    return `${domain}${basePath}/${version}/${operation}`;
  }
  public getUrlByOperationPurpose(operation: string | undefined): string {
    if (!this.env) {
      throw new Error('env is null');
    }
    if (!operation) {
      throw new Error(`${operation} doesn't exists`);
    }
    const { domain, basePath, version } = this.env.api_consetimiento;
    return `${domain}${basePath}/${version}/${operation}`;
  }
}
